// Об'єднання класів (clsx) з розв'язанням конфліктів display-утиліт і кольорів теми.
// Без цього `cn('inline-flex …', 'hidden')` не ховав би елемент: у CSS Tailwind 4 `.inline-flex` іде після `.hidden`.
// Пізніший клас display / bg-<колір> / text-<колір> з тим самим набором варіантів (hover:, md: …) прибирає попередні.
import { clsx, type ClassValue } from 'clsx';

const DISPLAY = new Set([
  'block',
  'inline-block',
  'inline',
  'flex',
  'inline-flex',
  'grid',
  'inline-grid',
  'contents',
  'flow-root',
  'table',
  'table-row',
  'table-cell',
  'hidden',
]);

// Кольори теми (@theme inline у index.css, --color-*): префікси, за якими bg-/text- вважається кольором.
const COLOR_PREFIXES = [
  'bg',
  'surface',
  'divider',
  'border',
  'row-',
  'fg',
  'muted',
  'faint',
  'primary',
  'on-',
  'accent',
  'nav',
  'neutral',
  'info',
  'success',
  'warning',
  'danger',
  'lesson-',
  'parity-',
  'ring',
  'overlay',
  'white',
  'black',
  'transparent',
  'current',
  'inherit',
];

function isColorValue(value: string): boolean {
  const v = value.replace(/\/(\d+|\[[^\]]+\])$/, '');
  return COLOR_PREFIXES.some((p) => v === p || v.startsWith(p.endsWith('-') ? p : `${p}-`) || v === p.replace(/-$/, ''));
}

function splitVariants(token: string): [string, string] {
  let depth = 0;
  let cut = -1;
  for (let i = 0; i < token.length; i++) {
    const ch = token[i];
    if (ch === '[') depth++;
    else if (ch === ']') depth--;
    else if (ch === ':' && depth === 0) cut = i;
  }
  return [token.slice(0, cut + 1), token.slice(cut + 1)];
}

function conflictKey(token: string): string | null {
  const [variants, util] = splitVariants(token);
  if (!variants && DISPLAY.has(util)) return '|display';
  const m = /^(bg|text)-(.+)$/.exec(util);
  if (!m || !isColorValue(m[2])) return null;
  return `${variants}|${m[1]}`;
}

export function cn(...inputs: ClassValue[]): string {
  const tokens = clsx(...inputs)
    .split(/\s+/)
    .filter(Boolean);
  const last = new Map<string, number>();
  tokens.forEach((t, i) => {
    const k = conflictKey(t);
    if (k) last.set(k, i);
  });
  return tokens
    .filter((t, i) => {
      const k = conflictKey(t);
      return !k || last.get(k) === i;
    })
    .join(' ');
}
